import { findInvoices, getInvoiceById } from '@/api/finance.api';
import type { IFetchInvoicesParamsRequest, IInvoiceResponse, Invoice } from '@condo/domain';
import { useQuery } from '@tanstack/vue-query';
import { type MaybeRef, computed, unref } from 'vue';

export const useInvoices = (params: MaybeRef<IFetchInvoicesParamsRequest> = {}) => {
    return useQuery<IInvoiceResponse>(['invoices', params], () => findInvoices(unref(params)), {
        initialData: { invoices: [], total: 0 },
    });
};

export const useInvoice = (invoiceId: MaybeRef<number | null>) => {
    const enabled = computed(() => !!unref(invoiceId));

    return useQuery<Invoice | null>(
        ['invoice', invoiceId],
        () => {
            const id = unref(invoiceId);
            return id ? getInvoiceById(id) : null;
        },
        {
            enabled,
            initialData: null,
        },
    );
};
